import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";

export const addTicketApi = async (params) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.TICKET.ADD,
    data: {
      coll: params.coll,
      payload: params.payload,
    },
  });
};
